import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import ourStaff from '../../../helpers/ourStaff';

import PlayersDashboard from './Dashboard';
import NoMatch from '../../NoMatch';

const championshipsByPlatform = { 'mpg': 1, 'mln': 2, 'mgd': 3};
const Players = props => (
    <div id="players">
        { !props.location.search ? (
            <Redirect to={{
                pathname: '/mxi/players',
                search: `?championship=${championshipsByPlatform[props.user.mainPlatform] || '1'}`,
            }}/>
        ) : (
            <Switch>
                <Route exact path='/mxi/players' component={PlayersDashboard} />
                <Route component={NoMatch} />
            </Switch>
        )}
    </div>
);

Players.propTypes = {
    user: PropTypes.object.isRequired
};

export default connect(
    state => ({ user: ourStaff[state.authentication.userId] || state.authentication.user || {} })
)(Players);



// WEBPACK FOOTER //
// ./src/pages/MXI/Players/index.js